// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.mail-head[data-v-2c3ddc5c]{\n\tbackground-color: var(--main-gray-1);\n}\n.mail-head>*>*[data-v-2c3ddc5c]:nth-child(odd){\n\ttext-align: right;\n}\n.container[data-v-2c3ddc5c] {\n\theight: 500px;\n\ttext-align: center;\n}\n.img[data-v-2c3ddc5c]{\n\theight:100%;\n\twidth:100%;\n\tmax-height: 100%;\n\tmax-width: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
